export const route = window.route
